// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3aiIF","bigColWidth":"Table_bigColWidth__AeB6v","biggerColWidth":"Table_biggerColWidth__3Z2U3","row":"Table_row__2pkEl","col":"Table_col__1Iay6"};